import { FeatureCollection, Polygon } from "geojson";

export type ZoneActionDetails = {
  "action-title": string;
  "action-link": string;
  "action-id": string;
  "action-assigned-zones": Array<string>;
};

export type ZoneDetails = {
  zoneId: number;
  "zone-title": string;
  "zone-description": string;
  "zone-rulesId": string;
};

export type ZoneRulesTopics = {
  "topic-title": string;
  "topic-description": string;
  topics: Array<Topic>;
};
export type Topic = {
  "question-name"?: string;
  "question-description"?: string;
};

export type ZoneRules = {
  zoneId: number;
  updated: string;
  "zone-name": string;
  "rules-topics": Array<ZoneRulesTopics>;
};

export type Overview = {
  description: string;
  governmentResponse: string;
  governmentDescription: string;
};

export type SupportMental = {
  "support-mental-name": string;
  "support-mental-description": string;
  "support-mental-website-email": string;
  "support-mental-phone-number": string;
};
export type SupportFinancial = {
  "support-financial-name": string;
  "support-financial-description": string;
  "support-financial-website-email": string;
  "support-financial-phone-number": string;
};
export type SupportCharity = {
  "support-charity-name": string;
  "support-charity-description": string;
  "support-charity-website-email": string;
  "support-charity-phone-number": string;
};
export type SupportIndustry = {
  "support-industry-name": string;
  "support-industry-description": string;
  "support-industry-website-email": string;
  "support-industry-phone-number": string;
};

export type Reimbursement = {
  description: string;
  "more-information": string;
};

export type Hotline = {
  "response-hotline-number": string;
  "response-hotline-description": string;
};

export type EmergencyDetails = {
  created: string;
  id: string;
  published: string;
  status: string;
  updated: string;
  emergencyTitle: string;
  emergencyOrderUrl: string;
  mapLink: string;
  assets: Array<string>;
  emergencyDescription: string;
  producerInstructions: string;
  emergencyImageId: string;
  emergencySupportsId: string;
  latestUpdatesId: string;
  diseaseInfoId: string;
  zones: Array<ZoneDetails>;
  emergencyActions: Array<ZoneActionDetails>;
  "zones-rules"?: Array<ZoneRules>; 
  mapData?: EmergencyMapData;
  emergencyImage?: string;
};

export type GlobalContentDetails = {
  created: string;
  updated: string;
  contentPrivacyCollectionId: string;
}

export type EmergencyMapData = FeatureCollection<
  Polygon,
  {
    OBJECTID: number;
    distance: number;
    zoneType: number;
    Zone_Name: string;
    Shape__Area: number;
    Shape__Length: number;
  }
>;

export type MatrixMetadata = {
  id: string;
  name: string;
  status: {
    id: number;
    name: string;
  };
  created: {
    date: string;
  };
  updated: {
    date: string;
  };
  published: {
    date: string;
  };
  metadata: Record<string, Array<string>>;
};

export type DiseaseFact = {
  "facts-header": string;
  "facts-description": string;
};

export type DiseaseInfoDetails = {
  updated: string;
  link: string;
  facts: Array<DiseaseFact>;
};

export type SupportDetails = {
  updated: string;
  assistanceGuideLink: string;
  industry: Array<SupportIndustry>;
  financial: Array<SupportFinancial>;
  mental: Array<SupportMental>;
  charity: Array<SupportCharity>;
  reimbursement: Reimbursement;
  hotline: Hotline;
};

export type LatestUpdates = {
  "update-date": string;
  "update-description": string;
};

export type LatestUpdatesDetails = {
  updated: string;
  latestUpdates: Array<LatestUpdates>;
};

export const EmergencyStatus = {
  ARCHIVED: "archived",
} as const;